import * as React from 'react'
import Link from 'next/link'

import { Case, ObituaryMemory, ObituarySnippet } from '../../types'
import styles from './styles.module.scss'
import { routes } from '../../routes'

interface IProps {
  obituary?: ObituarySnippet | Case
  obituaryMemory: ObituaryMemory
  shouldLinkToMemory: boolean
}

const ObituaryMemoryImage: React.FC<IProps> = ({
  obituary,
  obituaryMemory,
  shouldLinkToMemory,
}) => {
  if (!obituaryMemory.image) {
    return null
  }

  if (shouldLinkToMemory) {
    return (
      <Link href={routes.memory(obituary, obituaryMemory)}>
        <a aria-label="View shared memory">
          <img alt="Shared memory" className={styles.image} src={obituaryMemory.image} />
        </a>
      </Link>
    )
  }

  return <img alt="Shared memory" className={styles.image} src={obituaryMemory.image} />
}

export default ObituaryMemoryImage
